var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "m14.754 13.57-2.833-2.824a6.598 6.598 0 0 0 1.408-4.081 6.665 6.665 0 1 0-6.664 6.664 6.598 6.598 0 0 0 4.081-1.408l2.825 2.833a.834.834 0 0 0 1.365-.271.833.833 0 0 0-.182-.912ZM1.666 6.666a4.998 4.998 0 1 1 9.997 0 4.998 4.998 0 0 1-9.997 0Z"
  })));
};
export default SvgSearch;